import { Box, Container } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import { validateFields } from "../../common/helper";
import * as yup from "yup";
import { useRecoilState } from "recoil";
import { ShowProgress } from "../../state/ShowProgress";
import { DeveloperApi } from "../../openApi/api";
import { developerApi } from "../../openApi";
import { ThemeLight } from "../../state/ThemeLight";

const SignUp = () => {
  const navigate = useNavigate();

  const [, setShowProgress] = useRecoilState(ShowProgress);
  const [themeLight] = useRecoilState(ThemeLight);

  const [username, setUsername] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [agreeTerm, setAgreeTerm] = useState<boolean>(false);
  const [subscribeNewsletter, setSubscribeNewsletter] =
    useState<boolean>(false);

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  const handleSignup = async () => {
    if (!(await validate())) {
      return false;
    }

    setShowProgress(true);
    developerApi
      .signup({ username, email, password, subscribeNewsletter })
      .then((res) => {
        setShowProgress(false);
        toast.success("Signup has been successed.", {
          theme: themeLight ? "light" : "dark",
        });

        navigate("/login");
      })
      .catch((err) => {
        setShowProgress(false);
        toast.error("Signup has been failed.", {
          theme: themeLight ? "light" : "dark",
        });
      });
  };

  const validate = async () => {
    try {
      await validateFields(
        yup.object().shape({
          username: yup.string().required("Please input the username."),
          email: yup
            .string()
            .required("Please input the email address.")
            .email("Please input the correct email address"),
          password: yup.string().required("Please input the password"),
          confirmPassword: yup
            .string()
            .required("Please input the confirm password."),
        }),
        ["username", "email", "password", "confirmPassword"],
        [username, email, password, confirmPassword]
      );
    } catch (err: any) {
      toast.warn(err.message, { theme: themeLight ? "light" : "dark" });
      return false;
    }

    if (password !== confirmPassword) {
      toast.warn("Please input the correct confirm password.", {
        theme: themeLight ? "light" : "dark",
      });
      return false;
    }

    if (!agreeTerm) {
      toast.warn("Please check Terms and Conditions.", {
        theme: themeLight ? "light" : "dark",
      });
      return false;
    }

    return true;
  };

  return (
    <Container className="container-xxl py-12 pt-sm-20 pb-sm-32">
      <Box className="col-sm-10 col-md-7 col-lg-5 col-xl-4 card mx-auto p-6">
        <Box className="text-center mb-5">
          <Box className="h4">Sign Up</Box>
          <Box className="text-muted mb-0">
            Already have an account? <Link to="/login">Sign In here</Link>
          </Box>
        </Box>

        <Box className="js-form-message form-group mb-4">
          <Box className="form-label">
            Username
            <HelpOutlineIcon className="text-icon" />
          </Box>
          <input
            name="ctl00$ContentPlaceHolder1$txtUserName"
            type="text"
            className="form-control form-control-lg py-3"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Box>

        <Box className="js-form-message form-group mb-4">
          <Box className="form-label">Email Address</Box>
          <input
            name="ctl00$ContentPlaceHolder1$txtUserName"
            type="text"
            className="form-control form-control-lg py-3"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>

        {/* <Box className="js-form-message form-group mb-4">
          <Box className="form-label">Confirm Email Address</Box>
          <input
            name="ctl00$ContentPlaceHolder1$txtUserName"
            type="text"
            className="form-control form-control-lg py-3"
            placeholder="Re-enter your email address"
          />
        </Box> */}

        <Box className="js-form-message form-group mb-4">
          <Box className="d-flex justify-content-between">
            <Box className="form-label">Password</Box>
          </Box>
          <Box className="form-group position-relative">
            <input
              name="ctl00$ContentPlaceHolder1$txtPassword"
              type={showPassword ? "text" : "password"}
              id="ContentPlaceHolder1_txtPassword"
              placeholder="*************"
              className="js-toggle-password form-control form-control-lg py-3"
              data-msg="Your password is invalid. Please try again."
              data-msg-required="Please enter your Password."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Box
              className="content-center position-absolute top-0 py-1.5"
              title="Password Toggle"
              style={{ right: ".5rem" }}
            >
              <button
                type="button"
                className="btn btn-sm btn-ghost-white"
                id="changePassTarget"
                style={{ width: "2.375rem", height: "2.375rem" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <VisibilityOffIcon className="text-icon" />
              </button>
            </Box>
          </Box>
        </Box>

        <Box className="js-form-message form-group mb-4">
          <Box className="d-flex justify-content-between">
            <Box className="form-label">Confirm Password</Box>
          </Box>
          <Box className="form-group position-relative">
            <input
              name="ctl00$ContentPlaceHolder1$txtPassword"
              type={showConfirmPassword ? "text" : "password"}
              id="ContentPlaceHolder1_txtPassword"
              placeholder="*************"
              className="js-toggle-password form-control form-control-lg py-3"
              data-msg="Your password is invalid. Please try again."
              data-msg-required="Please enter your Password."
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Box
              className="content-center position-absolute top-0 py-1.5"
              title="Password Toggle"
              style={{ right: ".5rem" }}
            >
              <button
                type="button"
                className="btn btn-sm btn-ghost-white"
                id="changePassTarget"
                style={{ width: "2.375rem", height: "2.375rem" }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <VisibilityOffIcon className="text-icon" />
              </button>
            </Box>
          </Box>
        </Box>

        <Box className="js-form-message form-check mb-4">
          <input
            name="ctl00$ContentPlaceHolder1$chkRemember"
            type="checkbox"
            id="ContentPlaceHolder1_chkRemember"
            className="form-check-input"
            checked={agreeTerm}
            onChange={(e) => setAgreeTerm(e.target.checked)}
          />
          <Box
            className="form-check-label"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
          >
            <Box>
              I agree to the <Link to="#">Terms and Conditions</Link>.
            </Box>
          </Box>
        </Box>
        <Box className="js-form-message form-check mb-4">
          <input
            name="ctl00$ContentPlaceHolder1$chkRemember"
            type="checkbox"
            id="ContentPlaceHolder1_chkRemember"
            className="form-check-input"
            checked={subscribeNewsletter}
            onChange={(e) => setSubscribeNewsletter(e.target.checked)}
          />
          <Box
            className="form-check-label"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
          >
            <Box>
              I would like to receive the UPCX Explorer newsletter and
              understand that I can{" "}
              <Link to="#" target="_blank">
                unsubscribe
              </Link>{" "}
              at any time.
            </Box>
          </Box>
        </Box>
        <input
          type="submit"
          name="ctl00$ContentPlaceHolder1$btnLogin"
          value="Create an Account"
          id="ContentPlaceHolder1_btnLogin"
          className="btn btn-lg btn-primary w-100 py-3 mt-2"
          onClick={handleSignup}
        />
      </Box>
    </Container>
  );
};

export default SignUp;
